var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg404Icon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 122,
    viewBox: "0 0 196 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.4009 40.8161L66.0836 40.3232L66.0597 40.2915C60.8269 39.7219 67.2351 51.2617 70.2203 45.2573L70.1974 45.2298L69.3067 45.8482C66.3301 47.4963 63.8722 41.8092 65.4009 40.8161Z",
    fill: "#0072BC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5977 11.9927V11.9945L55.5997 11.9927H55.5977Z",
    fill: "#0072BC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M113.846 9.52754L114.148 0.229004L100.198 10.554L100.019 16.8342L66.7932 40.8903L66.3182 41.234C65.2534 41.9255 66.9638 45.8823 69.0353 44.7357L69.6559 44.3059L71.8136 42.8055L97.3597 25.048L103.459 20.8217L109.077 22.3909L123.148 12.1844L113.846 9.52754Z",
    fill: "#0072BC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M137.676 64.3484L138.359 63.8551L138.335 63.8232C133.102 63.2542 139.51 74.7934 142.495 68.789L142.473 68.7617L141.582 69.3801C138.605 71.0276 136.148 65.3407 137.676 64.3484Z",
    fill: "#0072BC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M186.119 33.0584L186.422 23.7603L172.472 34.0848L172.292 40.3659L139.066 64.4217L138.592 64.765C137.527 65.4565 139.237 69.4134 141.309 68.2667L141.929 67.8369L144.087 66.3367L169.633 48.5798L175.732 44.3536L181.35 45.923L195.421 35.7155L186.119 33.0584Z",
    fill: "#0072BC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M114.706 115.333L115.389 114.839L115.364 114.808C110.132 114.239 116.54 125.778 119.525 119.773L119.502 119.746L118.612 120.364C115.635 122.012 113.177 116.325 114.706 115.333Z",
    fill: "#0072BC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M163.149 84.043L163.451 74.7451L149.501 85.0695L149.322 91.3505L116.096 115.406L115.621 115.75C114.556 116.441 116.267 120.398 118.338 119.252L118.959 118.822L121.116 117.321L146.662 99.5645L152.762 95.3384L158.38 96.9076L172.45 86.7001L163.149 84.043Z",
    fill: "#0072BC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5236 49.8099C111.461 49.8099 121.985 60.3347 121.985 73.2714C121.985 86.2078 111.46 96.7326 98.5236 96.7326C85.5872 96.7326 75.0624 86.2076 75.0624 73.2714C75.0624 60.3347 85.5872 49.8099 98.5236 49.8099ZM98.5236 37.4839C78.7588 37.4839 62.7363 53.5062 62.7363 73.2714C62.7363 93.0362 78.759 109.058 98.5236 109.058C118.289 109.058 134.311 93.0362 134.311 73.2714C134.311 53.5062 118.289 37.4839 98.5236 37.4839Z",
    fill: "#0072BC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5236 67.5982C101.652 67.5982 104.196 70.143 104.196 73.2709C104.196 76.3988 101.652 78.9436 98.5236 78.9436C95.3957 78.9436 92.8509 76.3988 92.8509 73.2709C92.8509 70.143 95.3957 67.5982 98.5236 67.5982ZM98.5236 58.6338C90.439 58.6338 83.8867 65.1865 83.8867 73.2711C83.8867 81.3544 90.4392 87.9082 98.5236 87.9082C106.607 87.9082 113.161 81.3544 113.161 73.2711C113.161 65.1865 106.607 58.6338 98.5236 58.6338Z",
    fill: "#0072BC"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Icon);
export default __webpack_public_path__ + "static/media/404-Icon.ff52f1a503345a8d27ceb4f39ff64af2.svg";
export { ForwardRef as ReactComponent };